const quickLinks = [
  { id: 'synopsis', label: '剧情简介' },
  { id: 'episodes', label: '分集看点' },
  { id: 'cast', label: '主要角色' },
  { id: 'stills', label: '精彩剧照' },
];

const moreLinks = [
  { id: 'highlights', label: '观看理由' },
  { id: 'reviews', label: '观众短评' },
  { id: 'faq', label: '常见问题' },
  { id: 'recommend', label: '相关推荐' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.6fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">俄罗斯妈妈</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-secondary-200">
              本站是围绕剧集《俄罗斯妈妈》整理的内容信息页，收录剧情简介、分集看点、角色介绍与观众短评，
              并提供中文字幕、高清版本的资源浏览入口，帮助观众快速了解与查找。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-secondary-100">中文字幕</span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-secondary-100">高清视频</span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-secondary-100">完整版收录</span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">更多内容</h3>
            <ul className="mt-4 space-y-2.5">
              {moreLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-6 text-secondary-300">
            页面剧情概述、分集标题与人物介绍为依据内容整理的一般性说明，具体以正片为准。本站不提供存储与上传服务。
          </p>
          <a
            href="#top"
            className="flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-secondary-700 px-3.5 py-2 text-xs text-secondary-100 transition-colors hover:bg-secondary-900 sm:self-auto"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}